import { render, staticRenderFns } from "./AcademicTab.vue?vue&type=template&id=44ff6e6c&scoped=true"
import script from "./AcademicTab.vue?vue&type=script&lang=js"
export * from "./AcademicTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff6e6c",
  null
  
)

export default component.exports